import { openKendoWindow, rebindEvent } from "scripts/Utilities/core";
import { getResource } from "scripts/Utilities/resources";
function init() {
    rebindEvent("click", ".forgotten-password-js", onForgottenPasswordClick);
}
function onForgottenPasswordClick(e) {
    e.preventDefault();
    openKendoWindow("ForgottenPassword", "Account", {}, {
        modal: true,
        title: getResource("ForgottenPassword"),
        width: "600px",
        resizable: true,
    });
}
init();
